module.exports = __webpack_public_path__ + "img/soil-sensor.b436e95a.svg";